import React from 'react';
import './SaveCancelButtons.css';
import { Button } from '../../button/Button';

export const SaveCancelButtons = ({ onCancel, onSave }) => {
  return (
    <div className="save-cancel-btn-container">
      <Button variant="secondary" onClick={onCancel}>Anuluj</Button>
      <Button variant="primary" onClick={onSave}>Zapisz</Button>
    </div>
  );
};